var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-col',{attrs:{"cols":"12"}},[_c('fee-list',{attrs:{"projectId":_vm.projectId},on:{"selectedFee":function($event){return _vm.setFee($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }